import React, { useContext, useEffect, useRef, useState } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
import { useLocation, useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import LabelWithInput from 'components/commom/LabelWithInput';
import LabelWithTextArea from 'components/commom/LabelWithTextArea';
import ReusableTabs from 'components/commom/Tab';
import InputAdornment from '@mui/material/InputAdornment';
import SelectInput from 'components/commom/SelectInput';
import { FormattedMessage, useIntl } from 'react-intl';
import { LocaleContext } from 'routes/Router';
import MailIcon from 'assets/images/WithoutLogin/mail.svg';
import PhoneIcon from 'assets/images/WithoutLogin/phone-icon.svg';
import UploadIcon from 'assets/images/WithoutLogin/camera.svg';
import { useDispatch, useSelector } from 'react-redux';
import { registerUploadAction } from 'store/registerUpload/registerUploadAction';
import AbsoluteLogoMobile from 'assets/images/WithoutLogin/absolute-logo-phone.svg';
import { registerProviderType } from 'store/registerProviderType/registerProviderTypeAction';
import { registerTitleType } from 'store/registerTitle/registerTitleAction';
import TabSwitch from 'components/commom/SwitchLabelInput';
import { registerQualification } from 'store/registerQualification/registerQualificationAction';
import { registerOnePost } from 'store/registerStepOne/registerStepOneAction';
import { getCity } from 'store/getCity/getCityAction';
import { registerUsers } from 'store/register/registerAction';
import { getReviewDetail } from 'store/registerReview/registerReviewAction';
import CheckValidation from 'utils/validate';
import { registerVerifyPost } from 'store/registerVerify/registerVeifyAction';
import LocalStorageManager from 'managers/LocalStorageManger';
import { registerProfessionalDetail } from 'routes/AppUrls';
import ReusableButton from 'components/commom/Button';
import Shimmer from 'components/commom/Shimmer';
import CommonToast from 'components/commom/CommonToast';

const RegistrationStepOne = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const brandImageFileInputRef = useRef([]);
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const { showToast } = CommonToast();
  const [isError, setIsError] = useState(false);
  const dispatch = useDispatch();
  const [providerData, setProviderData] = useState([]);
  const [doctorTitle, setDoctorTitle] = useState([]);
  const [qualificationData, setQualificationData] = useState([]);
  const stateUsers = useSelector((state) => state?.registerUserReducer?.users);
  const cityUsers = useSelector((state) => state?.getCityReducer?.users);
  const { locale } = useContext(LocaleContext);
  const [tab, setTab] = useState(1);
  const [tabCountryName, setTabCountryName] = useState('');
  const [profileUpload, setProfileUpload] = useState('');
  const [profileId, setProfileId] = useState('');
  const [formData, setFormData] = useState({
    providerName: '',
    email: '',
    country_code: '',
    mobileNumber: '',
    providerType: '7',
    title: '9',
    titleSlug: 'dermatologist',
    bio: '',
    highestQualification: '',
    highestQualificationId: '',
    state: '',
    city: '',
    stateId: '',
    cityId: '',
    latitude: '',
    longitude: '',
    streetAddress: '',
    zipCode: '',
    proof_of_address: '',
    proof_of_address_id: '',
    startTime: '',
    endTime: '',
  });
  const [tabDetails, setTabDetails] = useState();
  const registerReducerOne = useSelector(
    (state) => state?.registerOneReducer?.loading
  );

  const registerUploadReducer = useSelector(
    (state) => state?.registerUploadReducer?.loading
  );

  const reviewData = useSelector(
    (state) => state?.getReviewDetailReducer?.users?.data
  );

  useEffect(() => {
    verifyToken();
    getProviderData();
    getTitleData();
  }, []);

  const getProviderData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setProviderData(res?.data?.[0]?.values);
      },
      error: true,
      handleErrorFunction: (res) => {},
    };
    dispatch(registerProviderType('provider-type', external));
  };

  const getTitleData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setDoctorTitle(res?.data?.[0]?.values);
      },
      error: true,
      handleErrorFunction: (res) => {},
    };
    dispatch(registerTitleType('doctor-title', external));
  };

  const verifyToken = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        LocalStorageManager.setItem('userId', res?.data?.user_id);
        dispatch(
          getReviewDetail(res?.data?.user_id, {
            run: true,
            handleFunction: (res) => handleSuccess(res),
          })
        );
      },
      error: true,
      handleErrorFunction: (res) =>
        dispatch(
          getReviewDetail(LocalStorageManager.getItem('userId'), {
            run: true,
            handleFunction: (res) => handleSuccess(res),
          })
        ),
    };
    let body = {
      token: token,
    };
    dispatch(registerVerifyPost(body, external));
  };

  const handleSuccess = (res) => {
    const fileName = res?.data?.address?.address_proof
      ? res?.data?.address?.address_proof.split('/').pop()
      : null;
    setFormData((prevState) => ({
      ...prevState,
      providerName: res?.data?.full_name,
      email: res?.data?.email,
      country_code: res?.data?.country_code,
      mobileNumber: res?.data?.contact_number,
      providerType:
        res?.data?.provider_type !== null &&
        res?.data?.provider_type !== undefined
          ? res?.data?.provider_type?.id
          : '7',
      title:
        res?.data?.title !== null && res?.data?.title !== undefined
          ? res?.data?.title?.id
          : '9',
      titleSlug:
        res?.data?.title !== null && res?.data?.title !== undefined
          ? res?.data?.title?.slug
          : 'dermatologist',
      // ['titleSlug']: res?.data?.title?.slug,
      highestQualification: res?.data?.highest_qualification?.qualification,
      highestQualificationId: res?.data?.highest_qualification?.id,
      state: res?.data?.address?.state?.name,
      city: res?.data?.address?.city?.name,
      stateId: res?.data?.address?.state?.id,
      cityId: res?.data?.address?.city?.id,
      latitude: res?.data?.address?.latitude,
      longitude: res?.data?.address?.longitude,
      streetAddress: res?.data?.address?.address_line1,
      zipCode: res?.data?.address?.zip_code,
      bio: res?.data?.bio,
      proof_of_address: fileName,
    }));
    setProfileUpload(res?.data?.profile_image);
    setTab(res?.data?.address?.country?.id);
    setTabCountryName(res?.data?.address?.country?.name);
    dispatch(registerUsers(res?.data?.address?.country?.id));
    const external = {
      run: true,
      handleFunction: (res) => {
        setQualificationData(res?.data);
      },
      error: true,
      handleErrorFunction: (res) => {},
    };
    dispatch(
      registerQualification(
        tab,
        res?.data?.title !== null ? res?.data?.title?.slug : 'dermatologist',
        external
      )
    );
  };

  const handleChange = (event) => {
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'zipCode' ? value.replace(/\D/g, '').slice(0, 5) : value,
    }));
  };
  const handleInputChange = (event) => {
    const external = {
      run: true,
      handleFunction: (res) => {},
      error: true,
      handleErrorFunction: (res) => {},
    };
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value?.name,
      stateId: name === 'state' ? value?.id : prev.stateId,
      cityId: name === 'city' ? value?.id : name === 'state' ? '' : prev.cityId,
      latitude:
        name === 'city'
          ? value?.latitude
          : name === 'state'
            ? ''
            : prev.latitude,
      longitude:
        name === 'city'
          ? value?.longitude
          : name === 'state'
            ? ''
            : prev.longitude,
      ...(name === 'state' && { city: '' }),
    }));

    if (name === 'state') {
      dispatch(getCity(tab, value?.id, external));
    }
  };
  const handleQualificationChange = (event) => {
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      highestQualification: value?.qualification,
      highestQualificationId: value?.id,
    }));
  };
  const handleCheckboxChange = (e, name, id) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setQualificationData(res?.data);
      },
      error: true,
      handleErrorFunction: (res) => {},
    };
    setFormData((prevState) => ({
      ...prevState,
      [name]: id?.id,
      titleSlug: id?.slug,
      highestQualification:
        name === 'title' ? '' : prevState.highestQualification,
      highestQualificationId:
        name === 'title' ? '' : prevState.highestQualificationId,
    }));
    if (name === 'title') {
      dispatch(registerQualification(tab, id?.slug, external));
    }
  };

  const handleCheckProviderChange = (e, name, id) => {
    setFormData((prevState) => ({
      ...prevState,
      providerType: id?.id,
    }));
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: '.jpg, .png, .jpeg',
    onDrop: (acceptedFiles) => {
      let formData = new FormData();
      acceptedFiles.forEach((file) => {
        formData.append('filePath', file);
      });
      const external = {
        run: true,
        handleFunction: (res) => {
          setProfileUpload(res?.data?.[0]?.filePath);
          setProfileId(res?.data?.[0]?.id);
          showToast(res?.message, 'success');
        },
        error: true,
        handleErrorFunction: (res) => showToast(res?.message, 'error'),
      };
      dispatch(registerUploadAction(formData, external));
    },
  });

  const tabData = [
    { label: intl.formatMessage({ id: 'United States of America' }) },
    { label: intl.formatMessage({ id: 'Jamaica' }) },
  ];

  const handleTabChange = (val) => {
    setTab(val);
  };

  const handleBrandImageUpload = (index) => {
    brandImageFileInputRef.current[index]?.click();
  };

  const handleBrandImageFileChange = (e, index) => {
    const file = e.target.files?.[0];
    let Data = new FormData();
    Data.append('filePath', file);

    const external = {
      run: true,
      handleFunction: (res) => {
        const filePath = res?.data?.[0]?.filePath;
        const fileName = filePath ? filePath.split('/').pop() : null;

        setFormData((prev) => ({
          ...prev,
          proof_of_address: fileName,
          proof_of_address_id: res?.data?.[0]?.id,
        }));

        showToast(res?.message, 'success');
      },
      error: true,
      handleErrorFunction: (res) => showToast(res?.message, 'error'),
    };

    dispatch(registerUploadAction(Data, external));
  };

  const hanldeRegisterStepOne = () => {
    if (profileUpload === '') {
      showToast('Please upload Profile Image', 'error');
    } else if (!formData?.highestQualificationId) {
      showToast('Please add Highest Qualification', 'error');
    } else if (
      formData?.proof_of_address !== null &&
      formData?.proof_of_address !== undefined &&
      formData?.proof_of_address !== ''
    ) {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          navigate(registerProfessionalDetail(locale));
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };
      const error = CheckValidation(formData);
      setIsError(error);
      let address = {
        address_line1: formData?.streetAddress,
        country: tab,
        state: formData?.stateId,
        city: formData?.cityId,
      };
      let body = {
        bio: formData?.bio,
        provider_type_id: formData?.providerType,
        title_id: formData?.title,
        higher_qualification_id: formData?.highestQualificationId,
        ...(reviewData?.title?.id === 10 && {
          clinic_opens_at: formData?.startTime + ':00',
        }),
        ...(reviewData?.title?.id === 10 && {
          clinic_closed_at: formData?.endTime + ':00',
        }),
        address: address,
      };
      if (profileId === '') {
        delete body['profile_pic_id'];
      } else {
        body['profile_pic_id'] = +profileId;
      }
      if (
        formData?.proof_of_address_id !== null &&
        formData?.proof_of_address_id !== undefined &&
        formData?.proof_of_address_id !== ''
      ) {
        body['address_proof_id'] = formData?.proof_of_address_id;
      } else {
        delete body['address_proof_id'];
      }
      if (tabCountryName !== 'Jamaica') {
        address.zip_code = formData?.zipCode;
      }
      if (formData?.latitude !== null && formData?.latitude !== undefined) {
        address.latitude = formData.latitude;
      }
      if (formData?.longitude !== null && formData?.longitude !== undefined) {
        address.longitude = formData.longitude;
      }

      dispatch(
        registerOnePost(body, LocalStorageManager.getItem('userId'), external)
      );
    } else {
      showToast('Please upload Proof Of Address', 'error');
    }
  };

  const handleShiftChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <>
      <Row className="m-0 p-0 landing-image">
        <Row className="mb-4 pt-80 size-padding flex justify-center">
          <Col
            xs={12}
            sm={10}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="bg-gray-100 sm:bg-light-100 m-0 p-0"
          >
            <div class="p-16 sm:p-32">
              <div className="main-heading family_outfit_semiBold_600">
                Registration
              </div>
              <Row className="m-0 p-0">
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="m-0 p-0 d-none d-sm-flex"
                >
                  <p className="pt-24 m-0 fs-14 family_outfit_regular_400 lh-176 fc-C56616">
                    Step 1/4
                  </p>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="m-0 p-0 d-none d-sm-flex"
                >
                  <p className="pt-04 m-0 fs-18 family_outfit_semiBold_600 lh-2068 fc-292D32">
                    Personal Details
                  </p>
                </Col>
                <div className=" m-0 p-0 d-flex d-sm-none justify-content-between">
                  <div>
                    <p className="pt-24 m-0 fs-14 family_outfit_regular_400 lh-176 fc-C56616">
                      Step 1/4
                    </p>
                    <p className="pt-04 m-0 fs-18 family_outfit_semiBold_600 lh-2068 fc-292D32">
                      Personal Details
                    </p>
                  </div>
                  <div className="d-flex align-items-center mt-4">
                    <Image src={AbsoluteLogoMobile} alt={'icon'} />
                  </div>
                </div>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="m-0 p-0"
                >
                  <div className="d-flex align-items-center pt-16">
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>Drop the files here ...</p>
                      ) : (
                        <>
                          {profileUpload !== '' ? (
                            registerUploadReducer ? (
                              <Shimmer
                                width="88px"
                                height="88px"
                                borderRadius="50%"
                              />
                            ) : (
                              <div className="uploadPhoto">
                                <Image
                                  src={profileUpload}
                                  alt="Uploaded profile"
                                  className="uploadPhoto"
                                />
                              </div>
                            )
                          ) : (
                            <div className="uploadPhoto">
                              <div>
                                <Image src={UploadIcon} />
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    <div className="pl-12">
                      <p className="p-0 m-0 fs-16 family_outfit_medium_500 lh-20 fc-3C3C3C">
                        Add Profile Picture
                      </p>
                      <p className="pt-8 m-0 fs-14 family_outfit_regular_400 fc-A4AAB2">
                        A picture will help people recognize you
                      </p>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={6} lg={6} xl={6} xxl={6} className="m-0 p-0">
                  <div className="pt-16">
                    <LabelWithInput
                      label="Name"
                      placeholder="Provider Name"
                      name="providerName"
                      type="text"
                      value={formData?.providerName}
                      onChange={(e) => handleChange(e, 'providerName')}
                      disabled={true}
                    />
                  </div>
                </Col>

                <Col md={6} lg={6} xl={6} xxl={6} className="size-padding">
                  <div className="pt-8">
                    <TabSwitch
                      label={'Title'}
                      tabs={doctorTitle}
                      selectedTabValue={formData?.title}
                      tranferData={(e, value) =>
                        handleCheckboxChange(e, 'title', value)
                      }
                      disableSwitching={false}
                    />
                  </div>
                </Col>
                <Col sm={12} md={6} lg={6} xl={6} xxl={6} className="m-0 p-0">
                  <div className="pt-16">
                    <LabelWithInput
                      label="Email ID"
                      placeholder="Email ID"
                      name="email"
                      type="text"
                      value={formData?.email}
                      onChange={(e) => handleChange(e, 'email')}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Image
                              src={MailIcon}
                              alt="icon"
                              style={{ cursor: 'pointer' }}
                            />
                          </InputAdornment>
                        ),
                      }}
                      disabled={'true'}
                    />
                  </div>
                </Col>
                <Col
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="size-padding"
                >
                  <div className="pt-16">
                    <LabelWithInput
                      label="Mobile Number"
                      placeholder="Mobile Number"
                      name="mobileNumber"
                      type="text"
                      value={`${formData?.country_code} ${formData?.mobileNumber}`}
                      onChange={(e) => handleChange(e)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Image
                              src={PhoneIcon}
                              alt="icon"
                              style={{ cursor: 'pointer' }}
                            />
                          </InputAdornment>
                        ),
                      }}
                      disabled={'true'}
                    />
                  </div>
                </Col>
                <Col sm={12} md={6} lg={6} xl={6} xxl={6} className="m-0 p-0">
                  <div className="pt-12">
                    {formData?.titleSlug !== 'dermatologist' &&
                    formData?.titleSlug !== 'both' ? (
                      <TabSwitch
                        label={'Provider Type'}
                        tabs={providerData?.length && [providerData[0]]}
                        selectedTabValue={
                          providerData?.length && providerData[0]?.id
                        } // Preselect the first provider
                        tranferData={(e, value) =>
                          handleCheckboxChange(e, 'providerType', value)
                        }
                      />
                    ) : (
                      <TabSwitch
                        label={'Provider Type'}
                        tabs={providerData}
                        selectedTabValue={formData?.providerType}
                        tranferData={(e, value) =>
                          handleCheckProviderChange(e, 'providerType', value)
                        }
                      />
                    )}
                  </div>
                </Col>
                <Col md={6} lg={6} xl={6} xxl={6} className="size-padding">
                  <div className="pt-16">
                    <p className="p-0 m-0 fs-14 lh-176 fc-292D32 family_outfit_medium_500">
                      Highest Qualification
                    </p>
                    <SelectInput
                      placeholder={intl.formatMessage({
                        id: 'Highest Qualification',
                      })}
                      name={'highestQualification'}
                      value={formData?.highestQualification}
                      data={qualificationData}
                      onChange={(e) =>
                        handleQualificationChange(e, 'highestQualification')
                      }
                      errorText={
                        isError &&
                        isError?.highestQualification?.error &&
                        isError?.highestQualification?.errorMessage
                      }
                    />
                  </div>
                </Col>
                {reviewData?.title?.id === 10 && (
                  <Col md={6} lg={6} xl={6} xxl={6} className="size-padding">
                    <div className="pt-16">
                      <p className="p-0 m-0 mb-2 fs-14 lh-176 fc-292D32 family_outfit_medium_500">
                        Working Hours
                      </p>
                      <LabelWithInput
                        label="Start Time"
                        type="time"
                        name="startTime"
                        value={formData?.startTime}
                        disabled={false}
                        onChange={(e) =>
                          handleShiftChange('startTime', e.target.value)
                        }
                        errorText={
                          isError &&
                          isError?.startTime?.error &&
                          isError?.startTime?.errorMessage
                        }
                      />
                    </div>
                  </Col>
                )}
                {reviewData?.title?.id === 10 && (
                  <Col md={6} lg={6} xl={6} xxl={6} className="size-padding">
                    <div className="pt-32">
                      <p className="p-0 m-0 mb-2 fs-14 lh-176 fc-292D32 family_outfit_regular_400"></p>
                      <LabelWithInput
                        label="End Time"
                        type="time"
                        name="endTime"
                        value={formData?.endTime}
                        disabled={false}
                        onChange={(e) =>
                          handleShiftChange('endTime', e.target.value)
                        }
                        errorText={
                          isError &&
                          isError?.endTime?.error &&
                          isError?.endTime?.errorMessage
                        }
                      />
                    </div>
                  </Col>
                )}
                <Col xs={12} md={12} className="m-0 p-0">
                  <div className="pt-16">
                    <LabelWithTextArea
                      label="Bio"
                      placeholder={intl.formatMessage({ id: 'Write here...' })}
                      height="120"
                      multiline
                      name="bio"
                      value={formData?.bio}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </Col>
                <div className="main-heading pt-24 family_outfit_semiBold_600">
                  Residential Address
                </div>
                <p className="pt-16 m-0 fs-14 family_outfit_medium_500 lh-176 fc-292D32">
                  Country
                </p>
                <Col md={12} lg={12} xl={6} xxl={6} className="m-0 p-0">
                  <div className="pt-04">
                    <ReusableTabs
                      tabs={tabData}
                      defaultTab={tab}
                      currentTab={(val) => handleTabChange(val)}
                      background={'#864629'}
                      color={'#FFFFFF'}
                      disabled={'true'}
                    />
                  </div>
                </Col>
                <Col md={6} lg={6} xl={6} xxl={6} className="size-padding">
                  <div
                    className="d-flex flex-column"
                    style={{ borderBottom: '1px solid #efe3d7' }}
                  >
                    <label className="fs-14 family_outfit_medium_500 mb-2 fc-292D32">
                      Proof Of Address
                    </label>

                    <div className="d-flex pb-10">
                      <input
                        ref={brandImageFileInputRef}
                        type="file"
                        accept=".png, .jpg, .jpeg, .gif, .mp4, .pdf"
                        disabled={false}
                        style={{ display: 'none', width: '100%' }}
                        onChange={handleBrandImageFileChange}
                      />
                      <label
                        className="cursor-pointer d-flex align-items-center"
                        onClick={() => brandImageFileInputRef.current?.click()}
                      >
                        {formData?.proof_of_address ? (
                          <div className="pl-8 pt-0.5 fs-14 lh-176 fc-5B88E9 family_outfit_medium_500 underline decoration-1">
                            {formData?.proof_of_address}
                          </div>
                        ) : (
                          <div className="d-flex">
                            <div className="pl-8 pt-0.5 fs-14 lh-176 fc-C56616 family_outfit_medium_500 underline decoration-1 ...">
                              Upload file
                            </div>
                          </div>
                        )}
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="m-0 p-0">
                <Col md={6} lg={6} xl={6} xxl={6} className="m-0 p-0">
                  <div className="pt-16">
                    <p className="fs-14 lh-176 fc-292D32 family_outfit_regular_400">
                      State
                    </p>
                    <SelectInput
                      placeholder={intl.formatMessage({
                        id: 'Texas',
                      })}
                      name={'state'}
                      value={formData?.state}
                      data={stateUsers?.data}
                      onChange={(e) => handleInputChange(e, 'state')}
                      errorText={
                        isError &&
                        isError?.state?.error &&
                        isError?.state?.errorMessage
                      }
                    />
                  </div>
                </Col>
                <Col md={6} lg={6} xl={6} xxl={6} className="size-padding">
                  <div className="pt-16">
                    <p className="fs-14 lh-176 fc-292D32 family_outfit_regular_400">
                      City
                    </p>
                    <SelectInput
                      placeholder={intl.formatMessage({
                        id: 'Dallas',
                      })}
                      name={'city'}
                      value={formData?.city}
                      data={cityUsers?.data}
                      onChange={(e) => handleInputChange(e, 'city')}
                      disabled={!formData?.state?.length}
                      errorText={
                        isError &&
                        isError?.city?.error &&
                        isError?.city?.errorMessage
                      }
                    />
                  </div>
                </Col>
                <Col md={6} lg={6} xl={6} xxl={6} className="m-0 p-0">
                  <div className="pt-16">
                    <LabelWithInput
                      label="Street Address"
                      placeholder="Street Address"
                      name="streetAddress"
                      type="text"
                      value={formData?.streetAddress}
                      onChange={(e) => handleChange(e)}
                      errorText={
                        isError &&
                        isError?.streetAddress?.error &&
                        isError?.streetAddress?.errorMessage
                      }
                    />
                  </div>
                </Col>
                <Col md={6} lg={6} xl={6} xxl={6} className="size-padding">
                  <div className="pt-16">
                    {tabCountryName !== 'Jamaica' && (
                      <LabelWithInput
                        label="ZIP Code"
                        placeholder="ZIP Code"
                        name="zipCode"
                        type="text"
                        value={formData?.zipCode}
                        onChange={(e) => handleChange(e)}
                        errorText={
                          isError &&
                          isError?.zipCode?.error &&
                          isError?.zipCode?.errorMessage
                        }
                      />
                    )}
                  </div>
                </Col>
              </Row>
              <Row className="flex justify-end pt-32 mt-190 sm:mt-0">
                <Col
                  xs={12}
                  sm={12}
                  md={2}
                  lg={2}
                  xl={2}
                  xxl={2}
                  className="pt-16 sm-pt-0"
                >
                  <ReusableButton
                    fullWidth={true}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={2}
                  lg={2}
                  xl={2}
                  xxl={2}
                  className="pt-16 sm-pt-0"
                >
                  <ReusableButton
                    fullWidth={true}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="18px"
                    fontWeight="600"
                    padding="14px 55px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241  "
                    fontFamily="outfit_semiBold"
                    onClick={() => {
                      !registerReducerOne && hanldeRegisterStepOne();
                    }}
                    loading={registerReducerOne}
                  >
                    <FormattedMessage id="Next" />
                  </ReusableButton>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Row>
    </>
  );
};

export default RegistrationStepOne;
